import React, { useState } from 'react';
import { LuminousBreakLogo } from './LuminousBreakLogo';

export interface ClinicianProfile {
  name: string;
  clinic: string;
  email?: string;
  role?: string;
}

interface ClinicianAuthModalProps {
  isOpen: boolean;
  onClose: () => void;
  onLoginSuccess: (practitioner: ClinicianProfile) => void;
}

export const ClinicianAuthModal: React.FC<ClinicianAuthModalProps> = ({
  isOpen,
  onClose,
  onLoginSuccess,
}) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  if (!isOpen) return null;

  const handleGoogleSignIn = () => {
    setIsLoading(true);
    // Simulates Google Workspace OAuth 2.0 / SSO with automatic domain extraction
    setTimeout(() => {
      setIsLoading(false);
      const email = 'practitioner@luminousbreak.com';
      const clinicName = 'Care Circle Partner Clinic';

      onLoginSuccess({
        name: 'Care Lead Practitioner',
        clinic: clinicName,
        email: email,
        role: 'Licensed Care Specialist & Care Lead',
      });
      onClose();
    }, 500);
  };

  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(15, 23, 42, 0.65)',
        backdropFilter: 'blur(5px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000,
        padding: '16px',
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          backgroundColor: '#FFFFFF',
          borderRadius: '24px',
          maxWidth: '440px',
          width: '100%',
          padding: '36px 32px',
          boxShadow: '0 25px 60px rgba(0,0,0,0.22)',
          border: '1px solid #E2E8F0',
          position: 'relative',
        }}
      >
        <button
          onClick={onClose}
          aria-label="Close modal"
          style={{
            position: 'absolute',
            top: '20px',
            right: '20px',
            background: 'none',
            border: 'none',
            fontSize: '18px',
            cursor: 'pointer',
            color: '#64748B',
            padding: '4px',
            lineHeight: 1,
          }}
        >
          ✕
        </button>

        <div style={{ textAlign: 'center', marginBottom: '28px' }}>
          <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '14px' }}>
            <LuminousBreakLogo size={56} />
          </div>
          <h2 style={{ margin: 0, fontSize: '20px', fontWeight: 700, color: '#2D2826', letterSpacing: '2px', textTransform: 'uppercase' }}>
            Luminous Break
          </h2>
          <span style={{ fontSize: '13px', fontWeight: 600, color: '#749C8F', display: 'block', marginTop: '4px' }}>
            Clinician & Care Portal
          </span>
          <p style={{ margin: '6px 0 0', fontSize: '12.5px', color: '#685F5B' }}>
            Zero-knowledge telemetry & collaborative care studio
          </p>
        </div>

        {/* Google Workspace Single Sign-On Button */}
        <div style={{ marginBottom: '20px' }}>
          <button
            type="button"
            onClick={handleGoogleSignIn}
            disabled={isLoading}
            style={{
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '12px',
              backgroundColor: '#FFFFFF',
              border: '1.5px solid #CBD5E1',
              borderRadius: '12px',
              padding: '14px 16px',
              fontSize: '14.5px',
              fontWeight: 600,
              color: '#1E293B',
              cursor: 'pointer',
              transition: 'all 0.15s ease',
              boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
            }}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" style={{ flexShrink: 0 }}>
              <path
                fill="#4285F4"
                d="M23.745 12.27c0-.7-.06-1.4-.19-2.07H12v4.51h6.6c-.29 1.52-1.14 2.82-2.4 3.68v3.05h3.88c2.27-2.09 3.66-5.17 3.66-9.17z"
              />
              <path
                fill="#34A853"
                d="M12 24c3.24 0 5.95-1.08 7.93-2.91l-3.88-3.05c-1.08.72-2.45 1.16-4.05 1.16-3.12 0-5.77-2.1-6.72-4.93H1.26v3.15C3.27 21.36 7.35 24 12 24z"
              />
              <path
                fill="#FBBC05"
                d="M5.28 14.27c-.25-.72-.38-1.49-.38-2.27s.13-1.55.38-2.27V6.58H1.26C.46 8.16 0 9.97 0 12s.46 3.84 1.26 5.42l4.02-3.15z"
              />
              <path
                fill="#EA4335"
                d="M12 4.75c1.77 0 3.35.61 4.6 1.8l3.42-3.42C17.95 1.19 15.24 0 12 0 7.35 0 3.27 2.64 1.26 6.58l4.02 3.15c.95-2.83 3.6-4.98 6.72-4.98z"
              />
            </svg>
            <span>
              {isLoading ? 'Verifying Google Workspace SSO...' : 'Continue with Google Workspace'}
            </span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ClinicianAuthModal;
